// useLoginFormState.js

import { useCallback, useEffect, useState } from 'react';

import { isValidEmail } from 'utilities/Validators';

const useLoginFormState = ({ onErrorClear }) => {
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [loginFormValid, setLoginFormValid] = useState(false);

  useEffect(() => {
    setLoginFormValid(
      loginEmail.length > 0 &&
      isValidEmail(loginEmail) &&
      loginPassword.length > 0
    );
  }, [loginEmail, loginPassword]);

  const handleLoginEmailChange = useCallback((value) => {
    setLoginEmail(value);
    onErrorClear && onErrorClear();
  }, [onErrorClear]);

  const handleLoginPasswordChange = useCallback((value) => {
    setLoginPassword(value);
    onErrorClear && onErrorClear();
  }, [onErrorClear]);

  const resetLoginForm = useCallback(() => {
    setLoginEmail('');
    setLoginPassword('');
    setLoginFormValid(false);
  }, []);

  return {
    loginEmail,
    loginPassword,
    loginFormValid,
    handleLoginEmailChange,
    handleLoginPasswordChange,
    resetLoginForm,
  };
};

export default useLoginFormState;
